var _Path, _Path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path, Mask, G } from "react-native-svg";

function SvgAdvanced(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M18.69 4.448V2.643c0-.7-.575-1.27-1.284-1.27H1.662c-.709 0-1.284.57-1.284 1.27v7.514c0 .7.575 1.27 1.284 1.27h15.744c.71 0 1.284-.57 1.284-1.27V8.352h1.512c.54 0 .978-.432.978-.966V5.414a.972.972 0 00-.978-.966H18.69z",
    stroke: props.fillSecondary,
    strokeWidth: 0.756
  }), /*#__PURE__*/React.createElement(Mask, {
    id: "advanced_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 22,
    height: 11
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.8h21.558V1H0v10.8z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement(G, {
    mask: "url(#advanced_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: props.fillSecondary
  }, _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M1.891 9.972h4V2.745h-4v7.227zM6.891 10.014h5V2.786h-5v7.228zM12.891 10.014h4V2.786h-4v7.228z"
  }))));
}

export default SvgAdvanced;